export const Types = {
    SAVE_LIST_VIDEO: 'SAVE_LIST_VIDEO',
    SAVE_LIST_VIDEO_HOMEPAGE: 'SAVE_LIST_VIDEO_HOMEPAGE',
}
